import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import {
    APP_LEAVING,
    LEFT_NAV_TOGGLE,
    LOGIN_SET_THEME,
    ADD_THEME_LIST,
    CALCULATE_FONT_USAGE
} from '../constants/ActionTypes';
import { LEFT_MAIN_MENU_ITEMS } from '../constants/MenuItems';
import { walkMeEnvironmentMap } from "../constants";
import '../styles/styles.scss';
import Header from './layout/Header';
import Footer from './layout/Footer';
import { checkPermissions } from '../../lib/utils';
import LeftMainmenuItem from './helpers/LeftMainmenuItem';
import ModalPropertyHelp from './modals/ModalPropertyHelp';
import ModalProperty from './modals/ModalProperty';
import ModalThemeAndConfigHelp from './modals/ModalThemeAndConfigHelp';
import ModalThemeAndConfig from './modals/ModalThemeAndConfig';
import ModalSave from './modals/ModalSave';
import { ModalManageContentInfo } from './modals/ModalManageContentInfo';
import { ModalSessionExpiration } from './modals/ModalSessionExpiration';
import { FontLoader } from './widgets/FontLoader/FontLoader';
import { ACCESS_POINTS_GROUP } from '../constants/AccessPoints';
import {
    getPropertyTitle as getPropertyTitleAction,
    getThemeTitle as getThemeTitleAction,
    getConfigTitle as getConfigTitleAction
} from '../actions/global';
import { envValue } from "../../config/envUtils";
import { get } from 'lodash';

class App extends Component {
    constructor(props) {
        super(props);
        this.collapseMenu = this.collapseMenu.bind(this);
        this.onbeforeunload = this.onbeforeunload.bind(this);
        this.state = {
            isLoading: false
        };
    }

    componentDidMount() {
        window && (window.onbeforeunload = () => this.onbeforeunload());

        const envCode = envValue('ENV_CODE');
        if (envCode in walkMeEnvironmentMap) {
            const walkMeEnvironment = walkMeEnvironmentMap[envCode];
            var walkme = document.createElement('script');
            walkme.type = 'text/javascript';
            walkme.async = true;
            walkme.src = `https://cdn.walkme.com/users/23af5f2146334c06baa8612338fc338e${walkMeEnvironment}/walkme_23af5f2146334c06baa8612338fc338e_https.js`;
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(walkme, s);
            window._walkmeConfig = { smartLoad: true };
        }
    }

    componentWillUnmount() {
        window && (window.onbeforeunload = null);
    }

    onbeforeunload() {
        this.props.appLeaving();
        return null;
    }

    collapseMenu() {
        this.props.leftMenuToggle();
    }

    toggleLoading(isLoading) {
        this.setState({ isLoading });
    }

    shouldDisabledMenuItem(pageName) {
        switch (pageName) {
            case LEFT_MAIN_MENU_ITEMS.PAGES:
                return !(
                    this.props.permissionLabels.view ||
                    this.props.permissionLabels.edit ||
                    this.props.permissionConfiguration.view ||
                    this.props.permissionConfiguration.edit ||
                    this.props.permissionTrackingHooks.view ||
                    this.props.permissionTrackingHooks.edit
                );
            case LEFT_MAIN_MENU_ITEMS.THEMES:
                return !(
                    this.props.permissionThemes.view ||
                    this.props.permissionThemes.edit ||
                    this.props.permissionCustomContent.view ||
                    this.props.permissionCustomContent.edit
                );
            case LEFT_MAIN_MENU_ITEMS.MANAGE:
                return !(
                    this.props.permissionThemes.view ||
                    this.props.permissionThemes.edit ||
                    this.props.permissionConfiguration.view ||
                    this.props.permissionConfiguration.edit ||
                    this.props.permissionTrackingHooks.view ||
                    this.props.permissionTrackingHooks.edit
                );
            case LEFT_MAIN_MENU_ITEMS.ASSETS:
                return !(
                    this.props.permissionThemes.view ||
                    this.props.permissionThemes.edit ||
                    this.props.permissionCustomContent.view ||
                    this.props.permissionCustomContent.edit ||
                    this.props.permissionTrackingHooks.view ||
                    this.props.permissionTrackingHooks.edit
                );
            default:
                return true;
        }
    }

    indexPage(pageName) {
        const permissionThemes = this.props.permissionThemes.view || this.props.permissionThemes.edit;
        const permissionCustomContent =
            this.props.permissionCustomContent.view || this.props.permissionCustomContent.edit;
        const permissionTrackingHooks =
            this.props.permissionTrackingHooks.view || this.props.permissionTrackingHooks.edit;
        switch (pageName) {
            case LEFT_MAIN_MENU_ITEMS.THEMES:
                if (!permissionThemes && permissionCustomContent) {
                    return '/theme/customContent';
                } else {
                    return '/theme/colors';
                }
            case LEFT_MAIN_MENU_ITEMS.ASSETS:
                if (permissionThemes || permissionCustomContent) {
                    return '/assets/images';
                } else if (permissionTrackingHooks) {
                    return '/assets/tracking';
                } else {
                    return '/assets';
                }
            default:
                return '/';
        }
    }

    render() {
        const { sidebar, content, routes, getPropertyTitle, getThemeTitle, getConfigTitle, inContextTheme } = this.props;
        const filteredRoutes = routes.filter(elem => elem.path);
        let currentHelpPage = '';
        filteredRoutes.map(elem => {
            currentHelpPage = currentHelpPage + elem.path;
        });
        currentHelpPage = currentHelpPage.replace(/\//g, '');
        currentHelpPage = currentHelpPage.replace(/-/g, '').toLowerCase();
        if (currentHelpPage === '') {
            currentHelpPage = 'Reference%2Fhome';
        }
        const containerClassName = classnames('spark-content__wrapper--sticky-footer main-container', {
            collapsed: this.props.leftMenuCollapsed
        });
        const property = getPropertyTitle();
        const theme = getThemeTitle();
        const config = getConfigTitle();

        const children = sidebar || (
            <div>
                <nav className="leftnav-container">
                    <LeftMainmenuItem
                        link={`/${LEFT_MAIN_MENU_ITEMS.PAGES}`}
                        disabled={this.shouldDisabledMenuItem(LEFT_MAIN_MENU_ITEMS.PAGES)}
                        icon="spark-icon-documents"
                        title="Pages"
                        copy="Update settings and styles for each page."
                    />
                    <LeftMainmenuItem
                        link={this.indexPage(LEFT_MAIN_MENU_ITEMS.THEMES)}
                        disabled={this.shouldDisabledMenuItem(LEFT_MAIN_MENU_ITEMS.THEMES)}
                        icon="spark-icon-design-palette"
                        title="Theme"
                        copy="Update styles globally across the site."
                    />
                    <LeftMainmenuItem
                        link={`/${LEFT_MAIN_MENU_ITEMS.MANAGE}`}
                        disabled={this.shouldDisabledMenuItem(LEFT_MAIN_MENU_ITEMS.MANAGE)}
                        icon="spark-icon-tools"
                        title="Manage"
                        copy="Manage themes and configurations."
                    />
                    <LeftMainmenuItem
                        link={this.indexPage(LEFT_MAIN_MENU_ITEMS.ASSETS)}
                        disabled={this.shouldDisabledMenuItem(LEFT_MAIN_MENU_ITEMS.ASSETS)}
                        icon="spark-icon-tools"
                        title="Assets"
                        copy="Upload and manage files, images and custom scripts"
                    />
                </nav>
            </div>
        );
        const comment = `<!-- ID=${currentHelpPage} -->`;
        const currentURL = window.location.href;
        const isInContextThemePage = currentURL.includes('/theme/colors') && this.props.isThemeSbem;

        return (
            <div className={containerClassName}>
                {this.state.isLoading && (
                    <div className="loading-component">
                        <div />
                    </div>
                )}
                <FontLoader />
                <div dangerouslySetInnerHTML={{ __html: comment }} />
                <Header
                    property={property}
                    theme={theme}
                    config={config}
                    location={this.props.location.pathname}
                    currentHelpPage={currentHelpPage}
                />
                <div id="content" className="row bed-container" style={isInContextThemePage ? { backgroundColor: inContextTheme.light.background } : {}}>
                    <div className={"in-context-sidebar-container col-lg-3 main-menu-left"}>
                        <div className="leftnav-container-wrapper">{children}</div>

                        <div className="collapse-menu" style={{ left: 'min(25%, 290px)' }} onClick={this.collapseMenu}>
                            <i className="spark-icon spark-icon-arrow-chevron-left spark-icon--md" />
                        </div>
                    </div>
                    <div className={"content__main"}>
                        <div className="col-lg-11">
                            {React.Children.map(content || this.props.children, child =>
                                React.cloneElement(child, {
                                    router: this.props.router,
                                    route: this.props.route
                                })
                            )}
                        </div>
                    </div>
                </div>
                <Footer />
                {/* TODO: */}
                {/* <AllModal /> */}
                <ModalPropertyHelp />
                <ModalProperty toggleLoading={isLoading => this.toggleLoading(isLoading)} />
                <ModalThemeAndConfigHelp />
                <ModalThemeAndConfig toggleLoading={isLoading => this.toggleLoading(isLoading)} />
                <ModalSave />
                <ModalManageContentInfo />
                <ModalSessionExpiration />
            </div>
        );
    }
}

App.propTypes = {
    sidebar: PropTypes.element,
    content: PropTypes.element,
    children: PropTypes.element,
    leftMenuCollapsed: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
    return {
        auth: state.oauth,
        leftMenuCollapsed: state.app.leftMenu.collapsed,
        accessLevel: state.oauth.accessLevel,
        inContextBeta: get(state, 'app.selected.inContextBeta', false),
        permissionLabels: checkPermissions(state, ACCESS_POINTS_GROUP.LABELS),
        permissionThemes: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        permissionConfiguration: checkPermissions(state, ACCESS_POINTS_GROUP.CONFIGURATION),
        permissionCustomContent: checkPermissions(state, ACCESS_POINTS_GROUP.CUSTOM_CONTENT),
        permissionTrackingHooks: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS),
        inContextTheme: state.app.data.inContextTheme,
        isThemeSbem: state.app.selected.isThemeSbem
    };
};

const mapDispatchToProps = dispatch => {
    return {
        appLeaving: () => {
            dispatch({ type: APP_LEAVING });
        },
        leftMenuToggle: () => {
            dispatch({ type: LEFT_NAV_TOGGLE });
        },
        setTheme: (theme, code) => {
            dispatch({ type: LOGIN_SET_THEME, theme, code });
            dispatch({ type: CALCULATE_FONT_USAGE });
        },
        setThemeList: (themeList, defaultContentCode) => {
            dispatch({ type: ADD_THEME_LIST, themeList, defaultContentCode });
        },
        getPropertyTitle: () => {
            return dispatch(getPropertyTitleAction());
        },
        getThemeTitle: () => {
            return dispatch(getThemeTitleAction());
        },
        getConfigTitle: () => {
            return dispatch(getConfigTitleAction());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));



// WEBPACK FOOTER //
// ./src/components/App.js